import {
  ConcreteMaterialFilenameTemplateItem,
  ConcreteMixDesignFilenameTemplateItem,
  ConcretePlacementFilenameTemplateItem,
  ConcreteTestFilenameTemplateItem,
  ConcreteTestSetFilenameTemplateItem,
  ConcreteTestSetRelationFilenameTemplateItem,
} from '../classes/concrete'
import { dateOptions, defaultsTo } from '../utils'

export const ConcreteTestSubId = new ConcreteTestFilenameTemplateItem({
  id: 'E4A0A379-259F-4A39-ADC3-D98D168669D1',
  name: 'Test Sub ID',
  property: 'testSubId',
  help: 'Test Sub ID from Concrete Test table',
  exampleValue: 'PLA-0014-A',
})

export const ConcreteFieldNumber = new ConcreteTestFilenameTemplateItem({
  id: '9BBE03D8-0918-417D-A531-2F2EE4BD0069',
  name: 'Field Number',
  property: 'fieldNumber',
  help: `Manual Cylinder Number from Concrete Test table. ${defaultsTo({
    name: 'Manual Cylinder Number',
    property: 'Test Sub ID',
  })}`,
  exampleValue: 'PLA-0014',
})

export const ConcretePlacementId = new ConcretePlacementFilenameTemplateItem({
  id: '2C63FDBD-428C-46AE-AE6C-2A04613E92D2',
  name: 'Placement ID',
  property: 'placementId',
  help: 'Placement ID from Concrete Placement table',
  exampleValue: 'PLA-00140-P1',
})

export const ConcretePlacementDate = new ConcreteTestSetFilenameTemplateItem({
  id: '71CCACDF-0459-44F8-9B84-9DB6E15105B1',
  name: 'Placement Date',
  property: 'placementDate',
  ...dateOptions({
    name: 'Placement Date',
    tableNameSingular: 'Concrete Test Set',
  }),
})

export const ConcreteMixDesign = new ConcreteMixDesignFilenameTemplateItem({
  id: '2BF3A469-3282-4FC2-AE59-F42C440FEF4F',
  name: 'Mix Design',
  property: 'mixDesignNumber',
  help: 'Mix Design Number from Concrete Mix Design table',
  exampleValue: 'A6505A',
})

export const ConcreteClientMixDesign =
  new ConcreteMixDesignFilenameTemplateItem({
    id: '625DE545-CA76-45E0-A20B-253A1AB3159D',
    name: 'Client Mix Design Number',
    property: 'clientDesignNumber',
    help: 'Client Design Number from Concrete Mix Design table',
    exampleValue: 'A6505A',
  })

export const ConcreteClassification = new ConcreteMixDesignFilenameTemplateItem(
  {
    id: 'B9EC170A-3942-4645-851D-3291FA5F847C',
    name: 'Classification',
    property: 'class',
    help: 'Class from Concrete Mix Design table',
    exampleValue: 'AA(AE)',
  }
)

export const ConcretePlacementType = new ConcreteMaterialFilenameTemplateItem({
  id: 'D06236AC-F028-43F7-B7C8-9188056D9E85',
  name: 'Placement Type',
  property: 'placementType',
  help: 'Placement Type from Concrete Materials table',
  exampleValue: 'PCCP-Machine Pour',
})

export const ConcreteShortName = new ConcreteMaterialFilenameTemplateItem({
  id: 'CA13C44A-5338-47CD-A1B9-9FD658BE2969',
  name: 'Placement Type Short Name',
  property: 'shortName',
  help: 'PDF Naming Convention Name (Short Name) from Concrete Materials table',
  exampleValue: 'PCCP',
})

export const ConcreteTestSetId = new ConcreteTestSetFilenameTemplateItem({
  id: '0F21CE17-0FB0-4B98-ABF5-6FF1E4D0F380',
  name: 'Test Set ID',
  property: 'testSetId',
  help: 'Test Set ID from Concrete Test Set table',
  exampleValue: 'PLA-0014',
})

export const ConcretePlacementIds =
  new ConcreteTestSetRelationFilenameTemplateItem({
    id: '5DDC34C2-7B06-4649-9885-4D3D47C9F51C',
    name: 'Placement IDs',
    property: 'concretePlacements',
    subProperty: 'placementId',
    help: 'A list of Placement IDs from Concrete Placement table, joined with an underscore',
    exampleValue: 'PLA-00140-P1',
  })

export const ConcreteFieldNumbers =
  new ConcreteTestSetRelationFilenameTemplateItem({
    id: 'E8A22592-055C-4722-8DF0-EE2F4128DD49',
    name: 'Field Numbers',
    property: 'concreteTests',
    subProperty: 'fieldNumber',
    help: `A list of Manual Cylinder Numbers from Concrete Test table, joined with an underscore. ${defaultsTo(
      {
        name: 'Manual Cylinder Number',
        property: 'Test Sub ID',
      }
    )} for each Manual Cylinder Number`,
    exampleValue: 'PLA-0014_PLA-0015_PLA-0016',
  })

export const ConcreteTestSubIds =
  new ConcreteTestSetRelationFilenameTemplateItem({
    id: 'E8A22592-055C-4722-8DF0-EE2F4128DD49',
    name: 'Test Sub IDs',
    property: 'concreteTests',
    subProperty: 'testSubId',
    help: `A list of Test Sub IDs from Concrete Test table, joined with an underscore`,
    exampleValue: 'PLA-0014-A_PLA-0014-B_PLA-0014-C',
  })

export type ConcreteFilename =
  | typeof ConcreteTestSubId
  | typeof ConcreteFieldNumber
  | typeof ConcretePlacementId
  | typeof ConcretePlacementDate
  | typeof ConcreteMixDesign
  | typeof ConcreteClientMixDesign
  | typeof ConcreteClassification
  | typeof ConcretePlacementType
  | typeof ConcreteShortName
  | typeof ConcreteTestSetId
  | typeof ConcretePlacementIds
  | typeof ConcreteFieldNumbers
  | typeof ConcreteTestSubIds
